import React, { useEffect, useState } from "react"
import { Modal, Form, Input, DatePicker, Select, InputNumber, Alert } from "antd"
import { API } from "../utils/API"
import moment from "moment"

const NewOrderModal = (props) => {
	const [form] = Form.useForm()
	const [errorMessage, setErrorMessage] = useState("")
	const [products, setProducts] = useState([])

	useEffect(() => {
		API.getProducts().then((res) => {
			const sortedProducts = res.data.sort((a, b) => a.name.localeCompare(b.name))
			setProducts(sortedProducts)
		})
		form.resetFields()
		setErrorMessage("")
	}, [props.newOrderVisible])

	return (
		<Modal
			title="Create Order"
			visible={props.newOrderVisible}
			onCancel={() => props.setNewOrderVisible(false)}
			onOk={() => {
				form
					.validateFields()
					.then((values) => {
						values.order_number = values.order_number.trim()
						values.access_code = values.access_code.trim()
						values.download_expiration = values.download_expiration.format('YYYY-MM-DD HH:mm:ss')
						console.log(values)
						API.createOrder(values).then((res) => {
							if (res.ok) {
								props.setNewOrderVisible(false)
								API.getOrders().then((res) => props.setOrders(res.data))
							} else if (res.data.message.toLowerCase().includes("duplicate")) {
								setErrorMessage(
									"An order with this product serial number already exists. Please enter a unique product serial number."
								)
							}
						})
					})
					.catch((info) => {
						console.log("Validate Failed:", info)
					})
			}}
		>
			<Form
				form={form}
				initialValues={{ downloads_available: 2, download_expiration: moment().add(30, "days") }}
				labelCol={{
					span: 10,
				}}
				wrapperCol={{
					span: 14,
				}}
			>
				<Form.Item
					name="product"
					label="Product"
					rules={[
						{
							required: true,
							message: "'Product' is required",
						},
					]}
				>
					<Select options={products} fieldNames={{ label: "name", value: "name" }}></Select>
				</Form.Item>
				<Form.Item
					name="order_number"
					label="Order Number"
					rules={[
						{
							required: true,
							message: "'Order number' is required",
						},
					]}
				>
					<Input />
				</Form.Item>
				<Form.Item
					name="access_code"
					label="Product Serial Number"
					rules={[
						{
							required: true,
							message: "'Serial number' is required",
						},
					]}
				>
					<Input maxLength={16} />
				</Form.Item>
				<Form.Item
					name="downloads_available"
					label="Downloads Available"
					rules={[
						{
							required: true,
						},
					]}
				>
					<InputNumber min={0} />
				</Form.Item>
				<Form.Item
					name="download_expiration"
					label="Download Expiration"
					rules={[
						{
							required: true,
						},
					]}
				>
					<DatePicker allowClear={false} />
				</Form.Item>
				{errorMessage.length > 0 && (
					<Alert
						style={{ marginBottom: 20 }}
						message={errorMessage}
						type="error"
						closable
						onClose={() => setErrorMessage("")}
					/>
				)}
			</Form>
		</Modal>
	)
}

export default NewOrderModal
